module.exports = __webpack_public_path__ + "static/doctor-plantcanal-753913121dac12537bf9cc29064f8ac4.png";